import type { MasterData } from "../schema/master";
import { ELECTRICITY_SOURCES } from "./electricity-sources";
import { EMISSION_FACTORS } from "./emission-factors";
import { EXAMPLES } from "./examples";
import { GLOSSARY } from "./glossary";
import { METHOD_CONFIGS } from "./methods";
import { EQUIPMENT_TEMPLATES } from "./templates";
import { TECHNOLOGIES } from "./technologies";

export { ELECTRICITY_SOURCES, EMISSION_FACTORS, EXAMPLES, GLOSSARY, METHOD_CONFIGS, EQUIPMENT_TEMPLATES, TECHNOLOGIES };
export { ELECTRICITY_DRIVEN_TECHS, ELECTRICITY_PRESETS, PRODUCTION_CHAINS, ROUTES, type ElectricityPreset, type Route } from "./pathways";

/** 프로그램에 내장된 기본 마스터 데이터 , DB 시드의 원본이자 오프라인 폴백 */
export const DEFAULT_MASTER_DATA: MasterData = {
  factors: EMISSION_FACTORS,
  sources: ELECTRICITY_SOURCES,
  technologies: TECHNOLOGIES,
  templates: EQUIPMENT_TEMPLATES,
  methods: METHOD_CONFIGS,
  examples: EXAMPLES,
  glossary: GLOSSARY,
};
